export default "__VITE_ASSET__DBtm5fDx__"